import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import "./UnapprovedIdentifications.css"; // Import the CSS file

const UnapprovedIdentifications = () => {
  const [identifications, setIdentifications] = useState([]);
  const [selectedIdentification, setSelectedIdentification] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchIdentifications();
  }, []);

  const fetchIdentifications = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/identifications/unapproved`
      );
      console.log("Fetched identifications:", response.data);
      setIdentifications(response.data);
    } catch (error) {
      console.error("Error fetching identifications:", error);
    }
  };

  const handleDelete = async (ids) => {
    try {
      await Promise.all(
        ids.map((id) =>
          axios.delete(`${process.env.REACT_APP_API_URL}/identifications/${id}`)
        )
      );
      setIdentifications(
        identifications.filter((ident) => !ids.includes(ident.id))
      );
      setSelectedIds([]);
      if (selectedIdentification && ids.includes(selectedIdentification.id)) {
        setSelectedIdentification(null);
      }
    } catch (error) {
      console.error("Error deleting identifications:", error);
    }
  };

  const handleApprove = async (ids) => {
    try {
      await Promise.all(
        ids.map((id) =>
          axios.patch(
            `${process.env.REACT_APP_API_URL}/identifications/approve/${id}`
          )
        )
      );
      setIdentifications(
        identifications.filter((ident) => !ids.includes(ident.id))
      );
      setSelectedIds([]);
      if (selectedIdentification && ids.includes(selectedIdentification.id)) {
        setSelectedIdentification(null);
      }
    } catch (error) {
      console.error("Error approving identifications:", error);
    }
  };

  const handleRowClick = (ident) => {
    setSelectedIdentification((prev) => (prev?.id === ident.id ? null : ident));
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((selectedId) => selectedId !== id)
        : [...prev, id]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(identifications.map((ident) => ident.id));
    } else {
      setSelectedIds([]);
    }
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const offset = currentPage * itemsPerPage;
  const paginatedIdentifications = identifications.slice(
    offset,
    offset + itemsPerPage
  );

  return (
    <div className="container">
      <h1>Unapproved Identifications</h1>
      <div className="bulk-actions">
        <button
          onClick={() => handleApprove(selectedIds)}
          disabled={selectedIds.length === 0}
        >
          Approve Selected
        </button>
        <button
          onClick={() => handleDelete(selectedIds)}
          disabled={selectedIds.length === 0}
        >
          Not Approved Selected
        </button>
      </div>
      <table className="identification-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                onChange={handleSelectAll}
                checked={selectedIds.length === identifications.length}
              />
            </th>
            <th>Species Name</th>
            <th>Confidence</th>
            <th>User</th>
            <th>Identification Time</th>
            <th>Identified Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedIdentifications.map((ident) => (
            <React.Fragment key={ident.id}>
              <tr
                onClick={() => handleRowClick(ident)}
                className={
                  selectedIdentification?.id === ident.id ? "selected" : ""
                }
              >
                <td>
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(ident.id)}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleCheckboxChange(ident.id);
                    }}
                  />
                </td>
                <td>{ident.species}</td>
                <td>{(parseFloat(ident.conf) * 100).toFixed(2)}%</td>
                <td>{ident.user ? ident.user : "Guest"}</td>
                <td>{ident.time}</td>
                <td>
                  <img
                    src={`${process.env.REACT_APP_API_URL}/static/identified_pics/${ident.id}.jpg`}
                    alt={ident.species}
                    className="thumbnail"
                  />
                </td>
                <td className="buttons">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleApprove([ident.id]);
                    }}
                  >
                    Approve
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete([ident.id]);
                    }}
                  >
                    Not Approved
                  </button>
                </td>
              </tr>
              {selectedIdentification?.id === ident.id && (
                <tr className="image-row">
                  <td colSpan="6">
                    <div className="image-container">
                      <img
                        src={`${process.env.REACT_APP_API_URL}/static/identified_pics/${ident.id}.jpg`}
                        alt={ident.species}
                        className="thumbnail2"
                      />
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={"previous"}
        nextLabel={"next"}
        breakLabel={"..."}
        pageCount={Math.ceil(identifications.length / itemsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
    </div>
  );
};

export default UnapprovedIdentifications;
